export default {
  getGuidelineList: '/dev-api/recruit/basedatamanager/getGuidelineList', // 人员计划统计详情查询
  // login: '/dev-api/author/Logon/login', // 登录注册
  login: '/dev-api/messagemanage/Logon/login', // 登录注册
  getHomeQuestion: '/dev-api/recruit/getHomeQuestion', // 问题解答列表
  informMore: '/dev-api/recruit/home/informMore', // 通知列表
  inform: '/dev-api/recruit/home/inform', //通知详情
  register: '/dev-api/personalcenter/register', //注册
  getAllList: '/dev-api/recruit/basedatamanager/getAllPubList', //获取职位显示列表
  myNoticeview: '/dev-api/personalcenter/myNoticeview', //个人中心通知查看
  deliveryProgress: '/dev-api/personalcenter/deliveryProgress', //投递进展
  getByIDEmail: '/dev-api/personalcenter/getByIDEmail', // 获取当前人员邮箱
  updateEmail: '/dev-api/personalcenter/updateEmail', // 修改当前人员邮箱
  updatePassword: '/dev-api/personalcenter/updatePassword', // 修改当前人员密码
  updatePhone: '/dev-api/personalcenter/updatePhone', // 修改当前人员手机号
  myResume: '/dev-api/recruit/resume/myResume', // 获取当前人员简历


  getChooseBatch: '/dev-api/recruit/basedatamanager/getChooseBatch', // 查询发布批次
  getCurrentBantchDeplist: '/dev-api/recruit/getCurrentBantchDeplist', // 查询发布批次下的单位信息
  jobSearch: '/dev-api/recruit/jobSearch', // 根据单位查询职位信息
  jobDetail: '/dev-api/recruit/jobDetail', // 查询批次详情

  gwbbApply: '/dev-api/recruit/resumescreening/gwbbApply', // 岗位申请
  admissionTicket: '/dev-api/personalcenter/admissionTicket', // 获取准考证
  getByIDBmb: '/dev-api/personalcenter/getByIDBmb', // 获取准考证
  updatePhoto: '/dev-api/recruit/resume/updatePhoto', // 上传照片

  collectionRecord: '/dev-api/personalcenter/collectionRecord', // 查询收藏记录
  addCollectionRecord: '/dev-api/personalcenter/addCollectionRecord', // 新增收藏
  removeCollectionRecord: '/dev-api/personalcenter/removeCollectionRecord', // 取消收藏
  renderVerifyCodeImg: '/dev-api/author/verificationCode/getCaptcha', // 获取普通验证码
  checkCaptcha: '/dev-api/author/verificationCode/checkCaptcha', // 验证验证码
  download: '/dev-api/platservice/fileupload/download', // 下载附件
  queryPersonInfo: '/dev-api/recruit/resume/queryPersonInfo', // 预览附件或图片
  previewImage: '/dev-api/platservice/fileupload/previewImage', // 预览附件或图片





  getBasicInfo: '/dev-api/recruit/resume/getBasicInfo', // 获取简历基本信息
  updateBasicInfo: '/dev-api/recruit/resume/updateBasicInfo', // 修改简历基本信息
  getShzpInfo: '/dev-api/recruit/resume/getShzpInfo', // 获取社会招聘信息
  updateShzpInfo: '/dev-api/recruit/resume/updateShzpInfo', // 修改社会招聘信息
  getYjbysInfo: '/dev-api/recruit/resume/getYjbysInfo', // 获取应届毕业生信息
  updateYjbysInfo: '/dev-api/recruit/resume/updateYjbysInfo', // 修改应届毕业生信息



  getLearningExperienceByA00: '/dev-api/recruit/learningExperience/getLearningExperienceByA00', // 获取简历学习经历
  deleteLearningExperience: '/dev-api/recruit/learningExperience/deleteLearningExperience', // 删除简历学习经历
  addLearningExperience: '/dev-api/recruit/learningExperience/addLearningExperience', // 保存新增简历学习经历
  updateLearningExperience: '/dev-api/recruit/learningExperience/updateLearningExperience', // 修改简历学习经历

  getFamilyNumbersByA00: '/dev-api/recruit/familyNumbers/getFamilyNumbersByA00', // 获取简历家庭成员
  deleteFamilyNumber: '/dev-api/recruit/familyNumbers/deleteFamilyNumber', // 删除简历家庭成员
  addFamilyNumber: '/dev-api/recruit/familyNumbers/addFamilyNumber', // 保存新增简历家庭成员
  updateFamilyNumber: '/dev-api/recruit/familyNumbers/updateFamilyNumber', // 修改简历家庭成员

  getWorkExperienceByA00: '/dev-api/recruit/workExperience/getWorkExperienceByA00', // 获取简历工作经历
  deleteWorkExperience: '/dev-api/recruit/workExperience/deleteWorkExperience', // 删除简历工作经历
  addWorkExperience: '/dev-api/recruit/workExperience/addWorkExperience', // 保存新增简历工作经历
  updateWorkExperience: '/dev-api/recruit/workExperience/updateWorkExperience', // 修改简历工作经历
  getPlaceid: '/dev-api/recruit/resumescreening/getPlaceid', // 考点位置列表
  getCodeTableAndKeyWordAllItem: '/dev-api/recruit/common/codeTable/getCodeTableAndKeyWordAllItem', // 政治面貌


  queryJobByBatchId: '/dev-api/recruit/queryJobByBatchId', // 切换批次的单位及职位
  getTzggById: '/dev-api/messagemanage/getTzggById', // 查看公告详情
  setNoticeAn: '/dev-api/personalcenter/setNoticeAn', // 回复消息


  getByIDPhone: '/dev-api/personalcenter/getByIDPhone', // 手机号
  sendShortMessageCode: '/dev-api/personalcenter/sendShortMessageCode', // 发送短信验证码
  resetPasswd: '/dev-api/personalcenter/resetPasswd', // 重置手机密码


  admissionTicketLog: '/dev-api/personalcenter/setTicketLog', // 每次打印准考证记录一次

  allowApplyNum: '/dev-api/recruit/resumescreening/allowApplyNum', // 判断是否超过


}



// WEBPACK FOOTER //
// ./src/utils/api.js